// extracted by mini-css-extract-plugin
export default {"spinner":"e_SaaoiM7VKY2WZ2J8gn"};